import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import Alpine from 'alpinejs';
import { SwiperOptions } from 'swiper/types';

interface InsightCategoryComponent {
  swiper: Swiper | null;

  mobileMediaQuery: MediaQueryList;

  init(): void;

  initSwiper(domEl: HTMLElement, options: SwiperOptions): void;
}

export default function initInsightCategory() {
  Alpine.data(
    'insightCategory',
    (): InsightCategoryComponent => ({
      swiper: null,
      mobileMediaQuery: window.matchMedia('(max-width: 992px)'),

      init() {
        // @ts-ignore
        const page = this.$el;
        const trendingSliderEl = page.querySelector('.trending-swiper');
        const newsSliderEl = page.querySelector('.news-swiper');

        if (trendingSliderEl) {
          this.initSwiper(trendingSliderEl, {
            modules: [Autoplay, Navigation],
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            autoplay: {
              delay: 2500,
              disableOnInteraction: false,
            },
            navigation: {
              nextEl: '.trending-news-pagination .swiper-button-next',
              prevEl: '.trending-news-pagination .swiper-button-prev',
            },
            breakpoints: {
              768: {
                slidesPerView: 2,
                spaceBetween: 30,
                loop: trendingSliderEl.querySelectorAll('.swiper-slide').length > 2,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 20,
                loop: trendingSliderEl.querySelectorAll('.swiper-slide').length > 4,
              },
            },
          });
        }
        if (newsSliderEl) {
          this.initSwiper(newsSliderEl, {
            modules: [Autoplay, Navigation],
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            autoplay: {
              delay: 2500,
              disableOnInteraction: false,
            },
            navigation: {
              nextEl: '.news-swiper .swiper-button-next',
              prevEl: '.news-swiper .swiper-button-prev',
            },
            breakpoints: {
              992: {
                slidesPerView: 4,
                spaceBetween: 30,
              },
            },
          });
        }

        /** SPEAKERS */
        const speakerSlider = page.querySelector('.sw-CustomSpeakers');
        if (speakerSlider) {
          const { size } = speakerSlider.dataset;
          this.initSwiper(speakerSlider, {
            modules: [Autoplay, Navigation],
            slidesPerView: 1,
            spaceBetween: 10,
            autoHeight: true,
            loop: true,
            grid: {
              rows: 1,
              fill: 'row',
            },
            autoplay: {
              delay: 2500,
              disableOnInteraction: true,
              pauseOnMouseEnter: true,
            },
            navigation: {
              nextEl: '.sw-CustomSpeakers .swiper-button-next',
              prevEl: '.sw-CustomSpeakers .swiper-button-prev',
            },
            breakpoints: {
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              991: {
                slidesPerView: 'auto',
                loop: false,
                grid: {
                  rows: Math.floor(Number(size) / 4),
                  fill: 'row',
                },
                autoplay: false,
              },
            },
          });
        }
      },
      initSwiper(sliderEl, options) {
        this.swiper = new Swiper(sliderEl, options);
      },
    }),
  );
}
